import Immutable, { Immutable as ImmutableGenericType } from 'seamless-immutable'
import { Message } from 'react-intl'

export enum ModalDialogSeverityEnum {
  Hint = 1,
  Warning,
  Error,
  Inactivity,
}

export interface ModalDialogConfiguration {
  image?: any
  title?: any
  content?: any
  centerContent?: boolean
  customFooter?: any
  noFooter?: boolean
  closeButton?: {
    onClick?: Function
    text?: Message
  }
  secondButton?: {
    onClick?: Function
    text?: string
  }
  show: boolean
  severity?: ModalDialogSeverityEnum
  preferredWidth?: string
  id: string // Modal ID
}

export interface ModalDialogState {
  [x: string]: ModalDialogConfiguration
}

// @ts-ignore
export const initialState: ImmutableGenericType<ModalDialogState> = Immutable({})
